import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import FieldRow from '../../../FieldRow';
import { EMPTY_LIST } from '../../SnapdocsClosingSection.constants';
import { snapdocsListStyles } from '../../SnapdocsClosingSection.styles';
import { SnapdocsClosingSectionTestIds } from '../../SnapdocsClosingSection.testIds';
import {
  formatLenderReviewed,
  getDisplayValue,
  hasDisplayValue,
} from '../../SnapdocsClosingSection.utils';
import SnapdocsClosingBlock from '../SnapdocsClosingBlock';
import SnapdocsStatusBadge from '../SnapdocsStatusBadge';

import {
  notificationItemStyles,
  qualityControlRowsStyles,
} from './SnapdocsQualityControlBlock.styles';

const SnapdocsQualityControlBlock = ({ qualityControl = null, fallbackStatus, errorMessage }) => {
  const notifications = qualityControl?.notifications ?? EMPTY_LIST;
  const qualityControlStatus = qualityControl?.status ?? fallbackStatus;

  return (
    <SnapdocsClosingBlock
      dataTestId={SnapdocsClosingSectionTestIds.QUALITY_CONTROL_BLOCK}
      emptyMessage="No quality control review yet"
      errorMessage={errorMessage}
      headerContent={
        hasDisplayValue(qualityControlStatus) && (
          <SnapdocsStatusBadge status={qualityControlStatus} />
        )
      }
      isEmpty={!qualityControl}
      title="Quality Control"
    >
      <Box sx={qualityControlRowsStyles}>
        <FieldRow
          label="Lender Reviewed"
          value={formatLenderReviewed(qualityControl?.lenderReviewed)}
        />
        {notifications.length ? (
          <Box component="ul" sx={snapdocsListStyles}>
            {notifications.map(({ id, level, message }) => (
              <Box component="li" key={id} sx={notificationItemStyles}>
                <SnapdocsStatusBadge status={level} />
                <Typography color="text.secondary" variant="regular14">
                  {getDisplayValue(message)}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography color="text.secondary" variant="regular14">
            No quality control notifications
          </Typography>
        )}
      </Box>
    </SnapdocsClosingBlock>
  );
};

SnapdocsQualityControlBlock.propTypes = {
  errorMessage: PropTypes.string,
  fallbackStatus: PropTypes.string,
  qualityControl: PropTypes.shape({
    status: PropTypes.string,
    lenderReviewed: PropTypes.bool,
    notifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        level: PropTypes.string,
        message: PropTypes.string,
      }),
    ),
  }),
};

export default memo(SnapdocsQualityControlBlock);
